import axios from 'axios'

import { localApiEndpoints } from '../../constants/endpoints'

export interface LocalApiInterface {
  appConfig: () => Promise<any>
}

export const localApi: LocalApiInterface = {
  appConfig: () => axios.get(localApiEndpoints.appConfig),
}

export default localApi
